var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".Close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7052 8.70698C25.0957 8.31646 25.0957 7.6833 24.7052 7.29277C24.3146 6.90225 23.6815 6.90225 23.291 7.29277L15.9989 14.5849L8.70723 7.29324C8.31671 6.90272 7.68354 6.90272 7.29302 7.29324C6.90249 7.68377 6.90249 8.31693 7.29302 8.70746L14.5849 15.9993L7.29302 23.2912C6.90249 23.6817 6.90249 24.3149 7.29301 24.7054C7.68354 25.0959 8.3167 25.0959 8.70723 24.7054L15.9993 17.4133L23.291 24.7049C23.6815 25.0954 24.3146 25.0954 24.7052 24.7049C25.0957 24.3144 25.0957 23.6812 24.7052 23.2907L17.4133 15.9988L24.7052 8.70698Z",
    fill: "#202117"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalClose);
export default __webpack_public_path__ + "static/media/modal-close.3d85b53e24b392ac7523e5b4842b5ce0.svg";
export { ForwardRef as ReactComponent };